

// manager.js
export const managerPermissions = {
    create: {
      canCreateArticle: true,
      canCreateShop: true,
      canCreateCommande: true,
      canCreateOrdreDeLivraison: true,
      canCreateBonDeLivraison: true,
      canCreateEntree: true,
      canCreateSortie: true,
      canCreateFactureClient: true,
      canCreateFactureFournisseur: true,
      canCreateProforma: true,
      canCreateAvoirClient: true,
      canCreateAvoirFournisseur: true,
      canCreateFournisseur: true,
      canCreateBonDeTransfert: true,
      canCreateClient: true
    },
    update: {
      canUpdateArticle: true,
      canUpdateShop: true,
      canUpdateCommande: true,
      canUpdateOrdreDeLivraison: true,
      canUpdateBonDeLivraison: true,
      canUpdateEntree: true,
      canUpdateSortie: true,
      canUpdateFactureClient: true,
      canUpdateFactureFournisseur: true,
      canUpdateProforma: true,
      canUpdateAvoirClient: true,
      canUpdateAvoirFournisseur: true,
      canUpdateFournisseur: true,
      canUpdateBonDeTransfert: true,
      canUpdateClient: true
    },
    delete: {
      canDeleteArticle: true,
      canDeleteShop: true,
      canDeleteCommande: true,
      canDeleteOrdreDeLivraison: true,
      canDeleteBonDeLivraison: true,
      canDeleteEntree: true,
      canDeleteSortie: true,
      canDeleteFactureClient: true,
      canDeleteFactureFournisseur: true,
      canDeleteProforma: true,
      canDeleteAvoirClient: true,
      canDeleteAvoirFournisseur: true,
      canDeleteFournisseur: true,
      canDeleteBonDeTransfert: true,
      canDeleteClient: true
    },
    routing: {
      canAccessDashboard: true,
      canAccessArticles: true,
      canAccessShop: true,
      canAccessShopManagement: true,
      canAccessCommande: true,
      canAccessClientFournisseur: true,
      canAccessOrders: true,
      canAccessMouvementStock: true,
      canAccessUsers: true,
      canAccessStockGenerale:true
    },
    defaultRouting :"/Dashboard"
  };
  
  
  
// magasinier.js
export const magasinierPermissions = {
  create: {
    canCreateArticle: false,
    canCreateShop: false,
    canCreateCommande: false,
    canCreateOrdreDeLivraison: false,
    canCreateBonDeLivraison: true,
    canCreateEntree: true,
    canCreateSortie: true,
    canCreateFactureClient: false,
    canCreateFactureFournisseur: false,
    canCreateProforma: false,
    canCreateAvoirClient: false,
    canCreateAvoirFournisseur: false,
    canCreateFournisseur: false,
    canCreateBonDeTransfert: false,
    canCreateClient: false
  },
  update: {
    canUpdateArticle: false,
    canUpdateShop: false,
    canUpdateCommande: false,
    canUpdateOrdreDeLivraison: false,
    canUpdateBonDeLivraison: true,
    canUpdateEntree: true,
    canUpdateSortie: true,
    canUpdateFactureClient: false,
    canUpdateFactureFournisseur: false,
    canUpdateProforma: false,
    canUpdateAvoirClient: false,
    canUpdateAvoirFournisseur: false,
    canUpdateFournisseur: false,
    canUpdateBonDeTransfert: false,
    canUpdateClient: false
  },
  delete: {
    canDeleteArticle: false,
    canDeleteShop: false,
    canDeleteCommande: false,
    canDeleteOrdreDeLivraison: false,
    canDeleteBonDeLivraison: false,
    canDeleteEntree: false,
    canDeleteSortie: false,
    canDeleteFactureClient: false,
    canDeleteFactureFournisseur: false,
    canDeleteProforma: false,
    canDeleteAvoirClient: false,
    canDeleteAvoirFournisseur: false,
    canDeleteFournisseur: false,
    canDeleteBonDeTransfert: false,
    canDeleteClient: false
  },
  routing: {
    canAccessDashboard: true,
    canAccessArticles: false,
    canAccessShop: false,
    canAccessShopManagement: true,
    canAccessCommande: false,
    canAccessClientFournisseur: false,
    canAccessOrders: true,
    canAccessMouvementStock: true,
    canAccessUsers: false,
    canAccessStockGenerale:false
  },
  defaultRouting :"/Dashboard"

};

  
// commercial.js
export const commercialPermissions = {
  create: {
    canCreateArticle: false,
    canCreateShop: false,
    canCreateCommande: true,
    canCreateOrdreDeLivraison: false,
    canCreateBonDeLivraison: false,
    canCreateEntree: false,
    canCreateSortie: false,
    canCreateFactureClient: false,
    canCreateFactureFournisseur: false,
    canCreateProforma: false,
    canCreateAvoirClient: false,
    canCreateAvoirFournisseur: false,
    canCreateFournisseur: false,
    canCreateBonDeTransfert: false,
    canCreateClient: false
  },
  update: {
    canUpdateArticle: false,
    canUpdateShop: false,
    canUpdateCommande: true,
    canUpdateOrdreDeLivraison: false,
    canUpdateBonDeLivraison: false,
    canUpdateEntree: false,
    canUpdateSortie: false,
    canUpdateFactureClient: false,
    canUpdateFactureFournisseur: false,
    canUpdateProforma: false,
    canUpdateAvoirClient: false,
    canUpdateAvoirFournisseur: false,
    canUpdateFournisseur: false,
    canUpdateBonDeTransfert: false,
    canUpdateClient: false
  },
  delete: {
    canDeleteArticle: false,
    canDeleteShop: false,
    canDeleteCommande: false,
    canDeleteOrdreDeLivraison: false,
    canDeleteBonDeLivraison: false,
    canDeleteEntree: false,
    canDeleteSortie: false,
    canDeleteFactureClient: false,
    canDeleteFactureFournisseur: false,
    canDeleteProforma: false,
    canDeleteAvoirClient: false,
    canDeleteAvoirFournisseur: false,
    canDeleteFournisseur: false,
    canDeleteBonDeTransfert: false,
    canDeleteClient: false
  },
  routing: {
    canAccessDashboard: false,
    canAccessArticles: false,
    canAccessShop: false,
    canAccessShopManagement: false,
    canAccessCommande: true,
    canAccessClientFournisseur: false,
    canAccessOrders: false,
    canAccessMouvementStock: false,
    canAccessUsers: false,
    canAccessStockGenerale:false
  },
  defaultRouting :"/Commande"
};

  
  